import { EmbedSettingsResponseDto, JobOfferEmbedDetailsShowingV2ResponseDto } from "@/lib/interfaces/embed";
import { useMemo } from "react";

export function useJobPostsV2Display({
  sourceJobPost,
  embedBaseSettings,
  isLiveSettingsPreview,
  mergedColor,
}: {
  sourceJobPost: JobOfferEmbedDetailsShowingV2ResponseDto | undefined;
  embedBaseSettings: EmbedSettingsResponseDto | null;
  isLiveSettingsPreview: boolean;
  mergedColor: string;
}) {
  return useMemo(() => {
    if (!sourceJobPost) return sourceJobPost;

    const embedAllows =
      isLiveSettingsPreview
        ? true
        : (sourceJobPost.embedSettings?.showImage ?? embedBaseSettings?.showImage ?? true) !== false;

    let jobOfferPreview = { ...sourceJobPost.jobOfferPreview };
    let similarJobs = sourceJobPost.similarJobs;
    if (!embedAllows) {
      jobOfferPreview = { ...jobOfferPreview, showImage: false };
      if (similarJobs?.length) {
        similarJobs = similarJobs.map((j) => ({ ...j, showImage: false }));
      }
    }

    return {
      ...sourceJobPost,
      jobOfferPreview,
      similarJobs,
      organization: { ...sourceJobPost.organization, color: mergedColor },
      embedSettings: {
        ...(embedBaseSettings ?? {}),
        ...(sourceJobPost.embedSettings ?? {}),
      },
    };
  }, [embedBaseSettings, isLiveSettingsPreview, mergedColor, sourceJobPost]);
}
